import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit} from "@angular/core";
import {StromcheckAnfrage} from "../../anfrage/stromcheck.anfrage";
import {ElementService} from "../../../services/element.service";

@Component({
    selector: 'app-analyse',
    templateUrl: './analyse.component.html',
    standalone: false
})

export class AnalyseComponent implements OnInit, AfterViewInit {
  /**
   * get stromcheckanfrage
   */
  @Input() anfrage: StromcheckAnfrage;

  /**
   * Event emitter that fires always when class changes
   */
  @Input() classHasChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * Placeholder used in all texts
   */
  textPlaceholder: any = {};

  /**
   * Prefix for all used textkeys
   */
  @Input() textKeyPrefix: string = 'stromcheck.ergebnis.analyse';

  /**
   * toggle for the hint text
   */
  showHint: boolean = false;

  /**
   * constructor
   * @param elementService
   * @param element
   */
  constructor(private elementService: ElementService, private element: ElementRef) {
  }
  ngOnInit() {
    // get placeholder from backend
    this.textPlaceholder = this.anfrage?.result?.placeholder ?? {};

    // scroll up to result if class changes
    this.classHasChanged.subscribe(() => {
      // get updated values of placeholder from backend if class changes
      this.textPlaceholder = this.anfrage.result.placeholder;
    });
  }

  ngAfterViewInit() {
    this.elementService.initTooltips(this.element);
  }

}
